import useQueryState from "Components/Hooks/UseQueryState";
import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import { Card, CardBody } from "reactstrap";
import { defaultFilter, FilterType } from "../Filters";
import { getTotalPaymentsAmount } from "common/services/payments.service";
import Skeleton from "react-loading-skeleton";
import * as moment from "moment";
import { Link } from "react-router-dom";
import PaymentsModal from "pages/Payments/PaymentsModal";

const TotalSupport = () => {
  const [filter] = useQueryState<FilterType>("filter", defaultFilter);

  const [totalSupport, setTotalSupport] = useState(0);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const response: any = await getTotalPaymentsAmount({
          mdaId: filter?.mda?.value || undefined,
          regionId: filter?.region?.value || undefined,
          positionTypeId: filter?.positionType?.value || undefined,
          agencyId: filter?.agency?.value || undefined,
          paymentCategoryId: filter?.paymentCategory?.value || undefined,
          thematicAreaId: filter?.thematicArea?.value || undefined,
          sectorId: filter?.sector?.value || undefined,
          startDate: filter?.dateRange?.fromDate
            ? moment(filter.dateRange.fromDate)
                .toDate()
                .toLocaleDateString("en-CA")
            : undefined,
          endDate: filter?.dateRange?.toDate
            ? moment(filter.dateRange.toDate)
                .toDate()
                .toLocaleDateString("en-CA")
            : undefined,
        });

        setTotalSupport(response?.totalAmount);
      } catch (error) {
        console.warn("Error fetching total  support", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [
    filter?.agency?.value,
    filter?.dateRange?.fromDate,
    filter?.dateRange?.toDate,
    filter.mda,
    filter?.positionType?.value,
    filter?.paymentCategory?.value,
    filter?.region?.value,
    filter?.sector?.value,
    filter?.thematicArea?.value,
  ]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = (e?: React.MouseEvent) => {
    if (e) {
      e.preventDefault();
    }
    setIsModalOpen(!isModalOpen);
  };

  return (
    <>
      <Link to="#" onClick={toggleModal}>
        <Card>
          <CardBody>
            <div className="d-flex align-items-center">
              <div className="avatar-sm flex-shrink-0">
                <span className="avatar-title bg-light text-primary rounded-circle fs-3 material-shadow">
                  <i className={"align-middle ri-money-dollar-circle-fill"}></i>
                </span>
              </div>
              <div className="flex-grow-1 ms-3">
                <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">
                  Total Support
                </p>
                <h4 className=" mb-0">
                  {loading ? (
                    <Skeleton width={120} height={24} />
                  ) : (
                    <CountUp
                      start={0}
                      end={totalSupport}
                      decimals={2}
                      separator={","}
                      prefix={"$"}
                      duration={1}
                    />
                  )}
                </h4>
              </div>
            </div>
          </CardBody>
        </Card>
      </Link>
      <PaymentsModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        title="Total Support"
        filter={filter}
      />
    </>
  );
};

export default TotalSupport;
